import { Breadcrumbs, Chip } from '@mui/material';
import { useCallback, useMemo } from 'react';
import { useFileBrowserLocation } from '../../hooks';

interface IFileBrowserBreadcrumbsProps {
  location: string;
}

const FileBrowserBreadcrumbs = ({ location }: IFileBrowserBreadcrumbsProps) => {
  const { setLocation } = useFileBrowserLocation();

  const segments = useMemo(() => {
    if (location === '/') return ['root'];
    return ['root', ...location.split('/').filter(Boolean)];
  }, [location]);

  const handleCrumbClick = useCallback(
    (index: number) => {
      if (index === 0) {
        setLocation('/');
        return;
      }

      const newPath = `/${segments.slice(1, index + 1).join('/')}/`;
      setLocation(newPath);
    },
    [segments, setLocation],
  );

  return (
    <Breadcrumbs aria-label="breadcrumb" separator="›">
      {segments.map((label, index) => {
        const isCurrent = index === segments.length - 1;

        const crumbPath =
          index === 0 ? '/' : `/${segments.slice(1, index + 1).join('/')}/`;

        return (
          <Chip
            key={crumbPath} // stable, semantic key
            label={label}
            size="small"
            clickable={!isCurrent}
            onClick={isCurrent ? undefined : () => handleCrumbClick(index)}
            color={isCurrent ? 'primary' : 'default'}
            variant={isCurrent ? 'filled' : 'outlined'}
            sx={{
              fontWeight: isCurrent ? 700 : 500,
              cursor: isCurrent ? 'default' : 'pointer',
              ...(isCurrent
                ? {}
                : {
                    '&:hover': {
                      bgcolor: 'action.hover',
                    },
                  }),
            }}
          />
        );
      })}
    </Breadcrumbs>
  );
};

export default FileBrowserBreadcrumbs;
